<template>
  <el-dialog
    id="create-modal"
    class="form-modal"
    v-loading="createProcessing"
    :visible.sync="createVisible"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Add {{ createTypeHeader }}</h1>
        <div class="modal-actions col-2">
          <el-button
            type="primary"
            :disabled="macUsed || numUsed"
            @click="createOperation"
          >
            Create
          </el-button>
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
          >
            Cancel</el-button
          >
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          ></el-button>
        </div>
      </div>
    </div>

    <el-form>
      <el-tabs v-model="activeTabName">
        <!-- ⭐ GENERAL ⭐ -->
        <el-tab-pane label="General" name="General">
          <div v-if="activeExtType === 'paging'">
            <el-checkbox v-model="createForm.includeInDbn">
              Include in dial by name directory
            </el-checkbox>
            <el-checkbox v-model="createForm.includeInPb">
              Include in default phonebook
            </el-checkbox>
            <div class="inline-form-group">
              <el-col :span="11">
                <el-input
                  placeholder="Enter account number"
                  v-model="createForm.accountNumber"
                >
                  <template slot="prefix"> Account number </template>
                </el-input>
              </el-col>
              <el-col :span="1" />
            </div>
            <div class="inline-form-group">
              <el-col :span="11">
                <el-input
                  v-model="createForm.extNumber"
                  placeholder="Extension number"
                >
                  <template slot="prefix">Extension number</template>
                  <template slot="append" v-if="numUsed">
                    <in-use :inUse="numInUse" />
                  </template>
                </el-input>
              </el-col>
              <el-col :span="1" />
              <el-col :span="12">
                <el-input
                  v-model="createForm.extName"
                  placeholder="Extension name"
                >
                  <template slot="prefix">Extension name</template>
                </el-input>
              </el-col>
            </div>
            <div class="inline-form-group">
              <el-col :span="11">
                <dads-select
                  v-model="createForm.emergencyAddress"
                  placeholder="Select e911 location"
                  v-loading="locationsProcessing"
                  :disabled="!locationOptions.length"
                  filterable
                  style="margin: 0"
                >
                  <template slot="prefix">e911 Location</template>
                  <el-option
                    v-for="option in locationOptions"
                    :key="option.id"
                    :value="option.id"
                    :label="option.name"
                  />
                </dads-select>
              </el-col>
              <el-col :span="1" />
              <el-col :span="12">
                <el-input
                  v-model="createForm.emergencyLocation"
                  placeholder="e911 specific room/bldg/etc.."
                >
                  <template slot="prefix"> Location override </template>
                </el-input>
              </el-col>
            </div>
            <div class="inline-form-group">
              <div v-if="createForm.emergencyAddress">
                <el-tag class="address-tag">
                  <div>
                    <p class="address-label">
                    <strong>Address:</strong>
                    {{ address }}
                    <br/>
                    </p>
                    <p class="coordinates-label">
                    <strong>Lat/Long:</strong>
                    {{ latitude + ', ' + longitude }}
                    </p>
                  </div>
                </el-tag>
              </div>
            </div>
          </div>
          <div v-else>
            <el-checkbox
              v-model="createForm.enableMeet"
              :label="true"
              v-if="activeExtType === 'desk'"
              style="margin-left: 0"
            >
              <span>Enable video meetings</span>
            </el-checkbox>

            <el-checkbox
              v-model="createForm.enableTranscription"
              :label="true"
              v-if="activeExtType === 'desk'"
              style="margin-left: 0"
            >
              <span>Enable call insights</span>
            </el-checkbox>

            <el-checkbox
              v-model="enable911Override"
              v-if="activeExtType === 'sip' && !isSuper"
              style="margin-left: 0"
            >
              <span>Enable e911 override</span>
            </el-checkbox>

            <div class="inline-form-group">
              <el-col :span="11">
                <el-input
                  v-model="createForm.extNumber"
                  placeholder="Extension number"
                >
                  <template slot="prefix">Extension number</template>
                  <template slot="append" v-if="numUsed">
                    <in-use :inUse="numInUse" />
                  </template>
                </el-input>
              </el-col>
              <el-col :span="1" />
              <el-col :span="12">
                <el-input
                  v-model="createForm.extName"
                  placeholder="Extension name"
                >
                  <template slot="prefix">Extension name</template>
                </el-input>
              </el-col>
            </div>
            <el-input
              class="checkbox-append"
              v-model="email"
              clearable
              placeholder="Enter email"
              v-if="activeExtType === 'desk'"
            >
              <template slot="prefix">Email</template>
              <template slot="append">
                <el-checkbox
                  v-model="createForm.sendInvite"
                  :label="true"
                  v-if="activeExtType === 'desk' && email !== ''"
                >
                  <span>Send invite</span>
                </el-checkbox>
              </template>
            </el-input>
            <div class="inline-form-group">
              <el-col :span="11">
                <dads-select
                  v-model="createForm.emergencyAddress"
                  placeholder="Select e911 location"
                  v-loading="locationsProcessing"
                  :disabled="!locationOptions.length"
                  filterable
                  style="margin: 0"
                >
                  <template slot="prefix">e911 Location</template>
                  <el-option
                    v-for="option in locationOptions"
                    :key="option.id"
                    :value="option.id"
                    :label="option.name"
                  />
                </dads-select>
              </el-col>
              <el-col :span="1" />
              <el-col :span="12">
                <el-input
                  v-model="createForm.emergencyLocation"
                  placeholder="e911 specific room/bldg/etc.."
                >
                  <template slot="prefix"> Location override </template>
                </el-input>
              </el-col>
            </div>
            <div class="inline-form-group">
              <div v-if="createForm.emergencyAddress">
                <el-tag class="address-tag">
                  <div>
                    <p class="address-label">
                    <strong>Address:</strong>
                    {{ address }}
                    <br/>
                    </p>
                    <p class="coordinates-label">
                    <strong>Lat/Long:</strong>
                    {{ latitude + ', ' + longitude }}
                    </p>
                  </div>
                </el-tag>
              </div>
            </div>
            <div class="inline-form-group">
              <el-col :span="11">
                <dads-select
                  v-model="createForm.branchId"
                  :value="createForm.branchId"
                  placeholder="Select branch"
                  filterable
                >
                  <template slot="prefix">Branch</template>
                  <el-option
                    v-for="(item, index) in branchOptions"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  />
                </dads-select>
              </el-col>
            </div>

            <div v-if="activeExtType === 'desk'">
              <h2 class="form-section-header">Outbound recording</h2>
              <dads-select
                v-model="createForm.recording"
                placeholder="Select option"
              >
                <template slot="prefix"> Recording </template>
                <el-option
                  v-for="(item, index) in recordingOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </dads-select>
              <el-tag class="mb-1">
                <i class="el-icon-info" style="margin-right: 4px" />
                To enable inbound call recording, edit the phone numbers
              </el-tag>

              <div
                v-if="
                  createForm.recording === 'yes' ||
                  createForm.recording === 'nochange' ||
                  createForm.recording === 'yeschange'
                "
              >
                <h2 class="form-section-header">Email recording</h2>
                <el-input
                  v-model="createForm.emailRecording"
                  placeholder="Enter emails"
                >
                  <template slot="prefix"> Emails </template>
                </el-input>
              </div>
            </div>

            <div v-if="activeExtType === 'sip'">
              <h2 class="form-section-header">Authentication method</h2>
              <el-radio-group v-model="createForm.sipAuthType" class="mv-10">
                <el-radio-button label="auth">Normal auth</el-radio-button>
                <el-radio-button label="ipAuth">IP based auth</el-radio-button>
              </el-radio-group>
              <el-input
                v-model="createForm.sipAuthIp"
                placeholder="Enter public IP"
                v-if="createForm.sipAuthType === 'ipAuth'"
              >
                <template slot="prefix"> Public IP </template>
              </el-input>
            </div>

            <div v-if="activeExtType === 'sip'">
              <h2 class="form-section-header">Call paths</h2>
              <el-input
                v-model.number="createForm.callLimit"
                type="number"
                placeholder="Call paths"
              >
                <template slot="prefix">Call paths</template>
              </el-input>
              <h2 class="form-section-header mb-0">CID Source</h2>
              <dads-select
                v-model="createForm.trunkCidSource"
                placeholder="Select option"
              >
                <el-option
                  v-for="(item, index) in trunkCidSourceOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
                <template slot="prefix">CID Source</template>
              </dads-select>
            </div>

            <h2 class="form-section-header mb-0">Outbound caller id</h2>
            <dads-select
              v-model="createForm.cidNum"
              :value="createForm.cidNum"
              clearable
              filterable
              allow-create
              remote
              :remote-method="remoteMethodForOutboundCid"
              placeholder="Select caller id"
            >
              <template slot="prefix">Ext caller id</template>
              <el-option
                v-for="option in outboundCidNumbersOptions"
                :key="option.id"
                :value="option.label"
                :label="option.label | formatNumber"
              />
            </dads-select>

            <!-- ⭐ ADVANCED SETTINGS ⭐ -->
            <omnia-collapse
              title="Advanced"
              :active="collapseActive"
              @toggle="collapseActive = !collapseActive"
            >
              <el-checkbox v-model="createForm.includeInDbn">
                Include in dial by name directory
              </el-checkbox>
              <el-checkbox v-model="createForm.includeInPb">
                Include in default phonebook
              </el-checkbox>

              <div class="inline-form-group">
                <el-col :span="11">
                  <el-input
                    placeholder="Enter account number"
                    v-model="createForm.accountNumber"
                  >
                    <template slot="prefix"> Account number </template>
                  </el-input>
                </el-col>
                <el-col :span="1" />
                <el-col :span="12">
                  <el-input
                    v-model="createForm.department"
                    :value="createForm.department"
                    placeholder="Department"
                  >
                    <template slot="prefix">Department</template>
                  </el-input>
                </el-col>
              </div>

              <h2 class="form-section-header mb-0">7-digit dialing</h2>
              <el-input
                v-model="createForm.prefix"
                placeholder="Your area code"
                maxlength="3"
              >
                <template slot="prefix">Default area code</template>
              </el-input>
              <el-tag class="mb-10">
                <i class="el-icon-info" style="margin-right: 4px"></i>
                This allows making calls without dialing the area code first
              </el-tag>
            </omnia-collapse>
          </div>
        </el-tab-pane>

        <!-- ⭐ DEVICES ⭐ -->
        <el-tab-pane
          label="Devices"
          name="Devices"
          v-if="activeExtType !== 'sip' && activeExtType !== 'paging'"
        >
          <div v-if="activeExtType !== 'sip'">
            <h2
              class="form-section-header"
              style="margin-top: 0px"
              v-if="activeExtType !== 'sip'"
            >
              Devices
            </h2>
            <div v-if="deviceList.length === 0">
              <el-button @click="deviceType = 'New Device'" class="mt-10 mb-10">
                <div class="dashboard-button-group">
                  <v-svg
                    class="voxo-pink"
                    sprite="devices"
                    style="width: 20px; height: 20px"
                  />
                  <span>New device</span>
                </div>
              </el-button>
            </div>
            <div v-if="deviceList.length > 0">
              <dads-select
                v-model="deviceType"
                :value="deviceType"
                placeholder="Select device"
                v-if="activeExtType !== 'sip'"
                filterable
                clearable
              >
                <template slot="prefix">Device</template>
                <el-option value="Existing Device" label="Existing device" />
                <el-option value="New Device" label="New device" />
              </dads-select>
            </div>
          </div>
          <div v-if="deviceType === 'New Device'">
            <el-select
              @change="onPhoneModelSelection"
              :value="phPmIdValue"
              placeholder="Select phone model"
            >
              <template slot="prefix">Phone model</template>
              <el-option
                v-for="(item, index) in deviceModelList"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <div class="inline-form-group">
              <el-col :span="11">
                <el-input
                  v-model="createForm.newDevice.name"
                  placeholder="Enter device name"
                >
                  <template slot="prefix">Device name</template>
                </el-input>
              </el-col>
              <el-col :span="1" />
              <el-col :span="12">
                <!-- Mac Input Field with Mask -->
                <div class="el-input el-input--prefix">
                  <input
                    type="text"
                    autocomplete="off"
                    placeholder="Enter device MAC"
                    class="el-input__inner"
                    :value="createForm.newDevice.mac"
                    @input="
                      createForm.newDevice.mac =
                        $event.target.value.toUpperCase()
                    "
                    v-mask="'NN:NN:NN:NN:NN:NN'"
                  />
                  <span class="el-input__prefix">Device Mac</span>
                  <div v-if="macUsed" class="el-input-group__append">
                    <in-use :inUse="macInUse" />
                  </div>
                </div>
              </el-col>
            </div>
          </div>
          <div v-if="deviceType === 'Existing Device'">
            <dads-select
              v-model="createForm.existingDevice.id"
              :value="createForm.existingDevice.id"
              placeholder="Select device"
              filterable
              v-if="activeExtType !== 'sip'"
              :disabled="!deviceList.length"
            >
              <template slot="prefix">Device</template>
              <el-option
                v-for="option in deviceList"
                :key="option.id"
                :value="option.id"
                :label="option.name"
              />
            </dads-select>
          </div>
        </el-tab-pane>

        <!-- ⭐ NEVER MISS A CALL ⭐ -->
        <el-tab-pane
          label="Never Miss A Call"
          name="neverMissACall"
          v-if="activeExtType === 'desk'"
        >
          <h2 class="form-section-header">
            Additional Destinations
            <el-popover placement="bottom-start" trigger="hover" width="300">
              <template slot="reference">
                <i class="el-icon-question"></i>
              </template>
              <span class="black-text">
                This selection will be set as the offline, busy, and no answer
                destinations for the extension. If left blank, these will
                default to a voicemail box.
              </span>
            </el-popover>
          </h2>
          <div class="inline-form-group">
            <el-col :span="10">
              <el-select
                v-model="createForm.additionalDestType"
                placeholer="Select Type"
                @change="getAdditionalDestOptions"
              >
                <template slot="prefix"> Type </template>
                <el-option value="Call Group" label="Call Group" />
                <el-option value="Call Queue" label="Call Queue" />
                <el-option value="Time of Day" label="Time of Day" />
                <el-option
                  value="Virtual Receptionist"
                  label="Virtual Receptionist"
                />
              </el-select>
            </el-col>
            <el-col :span="1" />
            <el-col :span="13">
              <dads-select
                v-model="createForm.additionalDestName"
                filterable
                placeholder="Select Destination"
              >
                <template slot="prefix"> Name </template>
                <el-option
                  v-for="item in additionalDestOptions"
                  :label="item.name"
                  :value="item.name"
                  :key="item.id"
                />
              </dads-select>
            </el-col>
          </div>
        </el-tab-pane>

        <!-- ⭐ FAXING ⭐ -->
        <el-tab-pane
          label="Faxing"
          name="faxing"
          v-if="activeExtType === 'desk'"
        >
          <div class="inline-form-group">
            <el-checkbox
              v-model="createForm.enableOutboundFaxing"
              style="margin-left: 0"
              :disabled="!email"
            >
              Enable Outbound Faxing
            </el-checkbox>
          </div>
          <el-tag
            class="mb-10"
            type="warning"
            v-if="createForm.enableOutboundFaxing"
          >
            <i class="el-icon-warning" style="margin-right: 4px"></i>
            Enabling this feature may cause you to travel back in time.
          </el-tag>

          <div class="inline-form-group">
            <el-checkbox
              v-model="createForm.faxDirect"
              style="margin-left: 0"
              :disabled="!email"
            >
              Enable Direct Fax

              <el-popover
                class="black-text"
                placement="right"
                trigger="hover"
                width="300"
              >
                <span class="black-text">
                  This allows using a direct dial for fax or voice
                </span>
                <span slot="reference">
                  <i class="el-icon-question" style="margin-right: 4px"></i>
                </span>
              </el-popover>
            </el-checkbox>
          </div>

          <div v-if="createForm.enableOutboundFaxing">
            <h2 class="form-section-header mb-0">Fax Outbound Caller Id</h2>
            <dads-select
              v-model="createForm.faxCidNum"
              :disabled="!email"
              filterable
              allow-create
              remote
              :remote-method="remoteFaxOutboundCid"
              clearable
              placeholder="Select caller id"
            >
              <template slot="prefix">Fax Caller ID</template>
              <el-option
                v-for="option in faxOutboundCidOptions"
                :key="option.id"
                :value="option.label"
                :label="option.label | formatNumber"
              />
            </dads-select>
          </div>
          <el-tag class="mb-10" type="warning" v-if="!email">
            <i class="el-icon-warning" style="margin-right: 4px"></i>
            To enable faxing features, an email must be provided.
          </el-tag>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </el-dialog>
</template>

<script>
import DadsSelect from "@/components/select";
import InUse from "@/components/InUse";
import OmniaCollapse from "@/components/OmniaCollapse";
import feathersClient from "@/feathers/feathers-client";
import {debounce} from "lodash";
import {phoneNumberFormatter, isValidPhoneNumber} from "@/globals/globals";

export default {
  name: "CreateExtensionForm",
  props: {
    clearFormFields: {
      type: Boolean,
      required: true,
    },
    createProcessing: { required: true },
    createVisible: { required: true },
    createTypeHeader: { required: true },
    numInUse: { required: true },
    macInUse: { required: true },
    activeExtType: { required: true },
    locationsProcessing: { required: true },
    locationOptions: { required: true },
    branchOptions: { required: true },
    departmentOptions: { required: true },
    deviceList: { required: true },
    faxOutboundCidOptions: { required: true },
    outboundCidNumbersOptions: { required: true },
    deviceModelList: { required: true },
    dncList: { required: true },
  },
  components: { DadsSelect, InUse, OmniaCollapse },
  data() {
    return {
      collapseActive: false,
      activeTabName: "General",
      deliveryOptions: ["Phone", "Email"],
      deviceType: "",
      email: "",
      additionalDestOptions: [],
      recordingOptions: [
        { label: "Yes", value: "yeschange" },
        { label: "No", value: "no" },
        { label: "No, but allow start/stop", value: "nochange" },
      ],
      trunkCidSourceOptions: [
        { label: "PAI", value: "PAI" },
        { label: "RPID", value: "RPID" },
        { label: "FROM", value: "FROM" },
      ],
      enable911Override: false,
      createForm: {
        enableMeet: true,
        enableTranscription: false,
        faxCidNum: "",
        enableOutboundFaxing: false,
        faxDirect: false,
        unconditionalStatus: "",
        recording: "",
        emailRecording: "",
        extNumber: "",
        emergencyLocation: "",
        extName: "",
        email: "",
        sendInvite: false,
        emergencyAddress: null,
        department: "",
        branchId: null,
        sipUser: "",
        sipPass: "",
        sipAuthType: "auth",
        sipAuthIp: "",
        voicemailDelivery: "",
        cidNum: "",
        callLimit: null,
        additionalDestType: "",
        additionalDestName: "",
        trunkCidSource: "PAI",
        cidNums: [],
        existingDevice: {
          id: null,
        },
        newDevice: {
          name: "",
          mac: "",
          phPmId: 0,
        },
        // ⭐️ Advanced Settings ⭐️ //
        includeInDbn: true,
        includeInPb: true,
        accountNumber: "",
        doNotCalls: [],
        prefix: "",
      },
    };
  },

  async created() {
    await this.getDefaultBranch();
  },
  computed: {
    extensionNumber() {
      return this.createForm.extNumber;
    },
    extensionName() {
      return this.createForm.extName;
    },
    phPmIdValue() {
      return this.createForm.newDevice.phPmId === 0
        ? ""
        : this.createForm.newDevice.phPmId;
    },
    mac() {
      return this.createForm.newDevice.mac;
    },
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    macUsed() {
      return this.macInUse && this.macInUse.inUse;
    },
    numUsed() {
      return this.numInUse && this.numInUse.inUse;
    },
    user() {
      return this.$store.state.auth.user;
    },
    isSuper() {
      if (this.user) {
        return +this.user.userRole === 1;
      }
      return false;
    },
    locationInformation() {
      return this.locationOptions.find(x => +x.id === +this.createForm.emergencyAddress);
    },
    address() {
      return this.locationInformation.address.streetNum + ' ' + this.locationInformation.address.streetInfo + ', ' + this.locationInformation.address.city + ', ' + this.locationInformation.address.state + ' ' + this.locationInformation.address.postalCode;
    },
    latitude() {
      const latitude = this.locationInformation.address.loc.split(",")[0];
      return Number(latitude).toFixed(2);
    },
    longitude() {
      const longitude = this.locationInformation.address.loc.split(",")[1];
      return Number(longitude).toFixed(2);
    },
  },
  watch: {
    extensionNumber() {
      if (this.extensionNumber !== "") {
        this.$emit("checkNumber", this.extensionNumber);
      }
    },
    extensionName: debounce(function (value) {
      this.createForm.extName = this.checkName(value);
    }, 500),
    mac() {
      if (this.mac !== "") {
        this.$emit("checkMac", this.mac);
      }
    },
    clearFormFields() {
      if (this.clearFormFields) {
        this.email = "";
        this.clearFields(this.createForm);
        this.activeTabName = "General";
        this.deliveryOptions = ["Phone", "Email"];
        this.deviceType = "";
        this.createForm.enableMeet = true;
        this.getDefaultBranch();
      }
    },
    email(value) {
      if (!value) {
        this.createForm.sendInvite = false;
        this.createForm.email = "";
      } else {
        this.createForm.email = value;
      }
    },
    createVisible() {
      setTimeout(() => {
        this.createForm.includeInDbn = this.activeExtType === "desk";
        this.createForm.includeInPb = this.activeExtType === "desk";
      }, 100);
    },
  },
  methods: {
    checkName(value) {
      const newName = value.normalize('NFD');
      return newName.replace(/[^a-zA-Z0-9\s]/g, '');
    },
    onPhoneModelSelection(value) {
      this.createForm.newDevice.phPmId = value;
    },
    async getDefaultBranch() {
        try {
          const [defaultBranch] = await feathersClient.service("branches").find({
            query: {
              tenantId: this.selectedTenant.id,
              default: 1
            }
          });
          this.createForm.branchId = defaultBranch.id;
        } catch (error) {
        console.log(error)
        }
    },
    cancelOperation() {
      this.$emit("cancelOperation", this.createForm);
    },

    async createOperation() {
      // Validate fax outbound caller id is a valid phone number
      if (this.createForm.enableOutboundFaxing && this.createForm.faxCidNum) {
        if (!isValidPhoneNumber(this.createForm.faxCidNum)) {
          this.$notify({
            title: "Invalid Fax Caller ID",
            message: "Fax outbound caller id must be a valid phone number.",
            type: "error",
          });
          return;
        }
      }

      //check caller id number to see if we can assign a destination on the fly
      const cidNumberStatus = await feathersClient.service("dids").find({
        query: {
          tenantId: this.selectedTenant.id,
          number: this.createForm.cidNum.replace(
            /['":;/{}()[|\-.,<>?_=+ \]]/g,
            ""
          ),
        },
      });
      let cidNumAvail = false;
      if (cidNumberStatus.length) {
        cidNumAvail = cidNumberStatus[0].useStatus === "Available";
      }

      //if the number is available prompt user for destination option
      let assignDID = false;
      if (cidNumAvail) {
        await this.$confirm(
          "Assign selected caller id number as direct dial for this extension?",
          {
            type: "info",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
          }
        )
          .then(() => {
            assignDID = cidNumberStatus[0].id;
          })
          .catch(() => {
            assignDID = false;
          });
      }

      if (this.createForm.callLimit === null) {
        this.createForm.callLimit = 5;
      }

      let createBody = {
        ...this.createForm,
        extType: this.activeExtType,
      };

      if (this.activeExtType !== "paging") {
        createBody.assignDID = assignDID;
      }

      if (!this.createForm.existingDevice.id) {
        delete createBody.existingDevice;
      } else {
        delete createBody.newDevice;
      }

      if (this.activeExtType === "sip") {
        createBody.trunkEmergencyOverride = this.enable911Override
          ? "yes"
          : "none";
        createBody.existingDevice = {
          id: 0,
        };
        delete createBody.newDevice;
      }

      if (this.activeExtType !== "desk") {
        createBody.enableMeet = 0;
      }

      //make sure enable meet is inserted as int
      createBody.enableMeet = createBody.enableMeet ? 1 : 0;
      createBody.enableTranscription = createBody.enableTranscription ? 1 : 0;
      createBody.faxDirect = createBody.faxDirect ? 1 : 0;

      //make sure recording is right.
      createBody.recording =
        createBody.recording === "" ? "no" : createBody.recording;

      // ⭐️ Make sure includeInDbn & includeInPb is right ⭐️ //
      createBody.includeInDbn = createBody.includeInDbn ? "yes" : "no";
      createBody.includeInPb = createBody.includeInPb ? "yes" : "no";

      this.$emit("createOperation", createBody);
    },

    clearFields(form) {
      Object.keys(form).forEach((key) => {
        if (typeof form[key] === "string") {
          form[key] = "";
        }
        if (typeof form[key] === "boolean") {
          form[key] = false;
        }
        if (Array.isArray(form[key])) {
          form[key] = [];
        }
      });
      this.collapseActive = false;
      this.enable911Override = false;
      this.createForm.includeInDbn = true;
      this.createForm.includeInPb = true;
      this.createForm.sipAuthType = "auth";
      this.createForm.trunkCidSource = "PAI";
      this.createForm.callLimit = null;
      this.createForm.existingDevice = {
        id: null,
      };
      this.createForm.newDevice = {
        name: "",
        mac: "",
        phPmId: null,
      };
      this.createForm.emergencyAddress = null;
      this.createForm.branchId = null;
      this.$emit("formFieldsCleared");
    },

    remoteFaxOutboundCid(query) {
      this.$emit("remoteFaxOutboundCid", query);
    },

    remoteMethodForOutboundCid(query) {
      this.$emit("remoteMethodForOutboundCid", query);
    },

    getAdditionalDestOptions(val) {
      const optionServiceMap = {
        "Time of Day": "conditions",
        "Call Queue": "queues",
        "Virtual Receptionist": "ivrs",
        "Call Group": "huntlists",
      };

      feathersClient
        .service(optionServiceMap[val])
        .find({
          query: {
            tenantId: this.selectedTenant.id,
          },
        })
        .then((res) => {
          this.additionalDestOptions = res;
        });
    },
  },

  filters: {
    formatNumber(value) {
      return phoneNumberFormatter(value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variables";

.checkbox-group {
  max-width: 600px;
  margin: auto;
}

.el-tabs {
  max-width: 600px;
  margin: auto;
}

.dashboard-button-group {
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-checkbox {
  margin-left: 0;
}

.address-tag {
  height: auto;

  .address-label {
    margin-top: 0;
    margin-bottom: -10px;
  }

  .coordinates-label {
    margin-top: -10px;
    margin-bottom: 0;
  }
}
</style>
